<template>
    <div class="fixed bottom-0 right-0 z-30 lg:m-6">
        <transition name="slide-fade">
            <div
                v-if="show"
                class="px-4 py-3 text-teal-900 bg-white border-t-4 border-green-500 rounded-b shadow-md"
                role="alert"
            >
                <div class="flex">
                    <div class="py-1">
                        <svg
                            class="w-6 h-6 mr-4 text-green-500 fill-current"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                        >
                            <path
                                d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z"
                            />
                        </svg>
                    </div>
                    <div>
                        <div class="flex flex-col mb-4 lg:flex-row md:justify-between md:items-center md:mb-2">
                            <p class="mb-2 font-bold">
                                KYC not verified!
                            </p>
                            <div class="flex space-x-3">
                                <div
                                    class="px-3 py-0.5 rounded cursor-pointer bg-green-500 text-sm inline-block text-white hover:bg-green-400"
                                    @click="goto('kyc.create')"
                                >
                                    Submit KYC
                                </div>
                                <div
                                    class="px-3 py-0.5 rounded cursor-pointer text-sm inline-block text-green-500 border hover:bg-green-100"
                                    @click="hideKycAlert"
                                >
                                    Ignore
                                </div>
                            </div>
                        </div>

                        <p class="text-sm lg:w-96">
                            Please Submit Kyc First. Without valid and accepted Kyc most of the functions would be
                            disabled.
                        </p>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'KycAlert',

    data() {
        return {
            show: false,
        };
    },

    computed: {
        isKycCreatePage() {
            return this.$page.url.includes('/kyc/create');
        },

        ignoreKycAlert() {
            return this.$cookie.get('ignoreKyc');
        },
    },

    mounted() {
        if (
            this.$page.props.user
            && !this.isAdmin
            && !this.ignoreKycAlert
            && !this.isKycCreatePage
            && !this.isKycSubmitted
            && !this.isSalesperson
        ) {
            this.show = true;
        } else {
            this.show = false;
        }
    },

    methods: {
        hideKycAlert() {
            this.show = false;
            this.$cookie.set('ignoreKyc', true);
        },
    },
};
</script>
